import Vue from "vue"
Vue.mixin({
  methods: {
    /** 拷贝新对象, 避免地址引用拷贝 */
    $copyObject(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
  },
  
})



// WEBPACK FOOTER //
// ./src/mixin/object.js